export default __webpack_public_path__ + "static/media/rm-banner-mobile.35318c28.png";